<template>
  <div >

    <el-upload
        class="upload-demo"
        ref="upload"
        action=""
        :on-change="changFile"
        :on-remove="handleRemove"
        :file-list="fileList"
        :auto-upload="false">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>


  </div>

</template>

<script>
import axios from "@/axios";
export default {
  name: "Shop",
  data() {
    return {
      fileList: [],
      uploadForm:null
    }
  },

  methods: {
    submitUpload(param) {
      this.uploadForm = new FormData();
      for (let i = 0; i < this.fileList.length; i++) {
        this.uploadForm.append(`files`, this.fileList[i].raw);
      }
      axios.post('/shop/upload', this.uploadForm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(res => {
        console.log("上传成功");
      }).catch(err => {
        console.log(err);
      });

      this.$refs.upload.submit();
    },
    changFile(file, fileList) {
      console.log(fileList);
      //选择文件后，给fileList对象赋值
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    }
  }

}
</script>

<style scoped>
</style>
